import { render, staticRenderFns } from "./HomeCare.vue?vue&type=template&id=68a2f18c"
import script from "./HomeCare.vue?vue&type=script&lang=js"
export * from "./HomeCare.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports